import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { LightScheme, ModernColors } from '@freenow/wave';

import App from './App';

const container = document.getElementById('root'); // find the DOM node to mount
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <>
            <ModernColors />
            <LightScheme>
                <App />
            </LightScheme>
        </>
    </React.StrictMode>,
); // render the app
